<template>
  <span class="country-flag" :title="country">
    <svg v-if="code === 'fi'" viewBox="0 0 30 20" class="flag-svg" aria-hidden="true">
      <rect width="30" height="20" fill="#ffffff"/>
      <rect x="10" width="4" height="20" fill="#002f6c"/>
      <rect y="8" width="30" height="4" fill="#002f6c"/>
    </svg>
    <svg v-else-if="code === 'es'" viewBox="0 0 30 20" class="flag-svg" aria-hidden="true">
      <rect width="30" height="20" fill="#aa151b"/>
      <rect y="5" width="30" height="10" fill="#f1bf00"/>
    </svg>
    <svg v-else-if="code === 'it'" viewBox="0 0 30 20" class="flag-svg" aria-hidden="true">
      <rect width="30" height="20" fill="#ffffff"/>
      <rect width="10" height="20" fill="#009246"/>
      <rect x="20" width="10" height="20" fill="#ce2b37"/>
    </svg>
    <i v-else class="fas fa-globe flag-fallback" aria-hidden="true"></i>
  </span>
</template>

<script>
const COUNTRY_CODES = {
  Finland: 'fi',
  Spain: 'es',
  Italy: 'it'
}

export default {
  name: 'CountryFlag',
  props: {
    country: {
      type: String,
      default: null
    }
  },
  computed: {
    code() {
      return this.country ? COUNTRY_CODES[this.country] : null
    }
  }
}
</script>

<style scoped>
.country-flag {
  display: inline-flex;
  align-items: center;
}

.flag-svg {
  width: 22px;
  height: auto;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  vertical-align: middle;
}

.flag-fallback {
  color: var(--text-muted);
}
</style>
